import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
	{
		path: '',
		loadChildren: () => import('./pages/start/start.module').then((m) => m.StartPageModule)
	},
	{
		path: 'error',
		loadChildren: () => import('./pages/error/error.module').then((m) => m.ErrorPageModule)
	}
];
@NgModule({
	imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
	exports: [RouterModule]
})
export class AppRoutingModule {}
